import { precogAccountingConstants } from "../../../actions/precog/accounting";

const defaultState = {
  status: {
    started: false,
    ended: false,
    error: false
  },
  data: []
};

export function accountingCodes(state = defaultState, { type, payload }) {
  switch (type) {
  case precogAccountingConstants.GET_ACCOUNTING_CODES_START:
    return {
      ...state,
      status: {
        started: true,
        ended: false,
        error: false
      }
    };
  case precogAccountingConstants.GET_ACCOUNTING_CODES_SUCCESS:
    return {
      ...state,
      status: {
        started: false,
        ended: true,
        error: false
      },
      data: payload?.data
    };
  case precogAccountingConstants.GET_ACCOUNTING_CODES_ERROR:
    return {
      ...state,
      status: {
        started: false,
        ended: true,
        error: true
      }
    };
  default:
    return state;
  }
}